import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const ImageHeaderContainer = styled(Flex, {
  marginBottom: '56px',
  justifyContent: 'center',
  marginTop: '24px',

  '@media (max-width: 464px)': {
    marginTop: '12px',
  },
});

export const StyledFAQContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: '24px',
});

export const OnboardingDisclaimerContainer = styled('div', {
  marginTop: '24px',
});

export const OnboardingHeading = styled('div', {
  fontSize: '32.45px !important',
  fontFamily: '$heading',
  lineHeight: '40px !important',
  color: '$core.color.brand.100',
  fontWeight: '600',
  '&.abyss-heading-root': {
    fontFamily: '$heading',
    fontWeight: '600',
  },
});
